import axios from "axios";
import { APP } from "@/config/app"

const api = axios.create({
    baseURL: APP.IsLocalhost ? undefined : APP.SignUpApi,
    headers: {
        "Content-Type": "application/json"
    }
});

export const authSignUp = async (payload) => {
    const response = await api.post("/auth/sign-up", payload);
    return {
        data: response.data,
        status: response.status,
    };
};

export const authConfirmSignUp = async (payload) => {
    const response = await api.post("/auth/sign-up/confirm", payload);
    return {
        data: response.data,
        status: response.status,
    };
};

export const authResendCode = async (payload) => {
    const response = await api.post("/auth/sign-up/resend-code", payload);
    return {
        data: response.data,
        status: response.status,
    };
};